import { MarketplaceNotification } from "../../../hooks/api"

export const isSubmittedProductApprovalNotification = (
  notification: MarketplaceNotification
) => notification.type === "product-approval.submitted"

export const getSubmittedApprovalMetadata = (
  notification: MarketplaceNotification
) => {
  const data = (notification.data ?? {}) as Record<string, unknown>

  return {
    approvalId: typeof data.approval_id === "string" ? data.approval_id : null,
    merchantName:
      typeof data.merchant_name === "string" && data.merchant_name.trim()
        ? data.merchant_name
        : null,
    productName:
      typeof data.product_name === "string" && data.product_name.trim()
        ? data.product_name
        : null,
    productThumbnail:
      typeof data.product_thumbnail === "string" && data.product_thumbnail.trim()
        ? data.product_thumbnail
        : null,
  }
}

export const getSubmittedCardDisplayContent = (
  notification: MarketplaceNotification
) => {
  const { merchantName, productName, productThumbnail } =
    getSubmittedApprovalMetadata(notification)

  return {
    title:
      merchantName && productName
        ? `${merchantName} • ${productName}`
        : notification.title,
    content:
      merchantName && productName
        ? `Sản phẩm ${productName} được gửi từ ${merchantName}`
        : notification.content ?? "Có sản phẩm mới đang chờ duyệt",
    productName,
    productThumbnail,
  }
}

export const getNotificationNavigationPath = (
  notification: MarketplaceNotification
) => {
  if (isSubmittedProductApprovalNotification(notification)) {
    const { approvalId } = getSubmittedApprovalMetadata(notification)

    if (approvalId) {
      return `/product-approvals/${approvalId}`
    }
  }

  return notification.action_url
}

export const handleNotificationItemClick = async ({
  notification,
  unread,
  markAsRead,
  navigate,
}: {
  notification: MarketplaceNotification
  unread: boolean
  markAsRead: (payload: { ids: string[] }) => Promise<unknown>
  navigate: (path: string) => void
}) => {
  try {
    if (unread) {
      await markAsRead({ ids: [notification.id] })
    }
  } finally {
    const targetPath = getNotificationNavigationPath(notification)
    if (targetPath) {
      navigate(targetPath)
    }
  }
}
